import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import './style/style.css';
import ScrollToTop from "./components/ScrollToTop";
import { ActiveNavBarProvider } from "./context/ActiveNavBarProvider";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { AboutUs } from "./pages/AboutUs";
import { ContactUs } from "./pages/ContactUs";
import { Services } from "./pages/Services";
import Fleet from "./pages/Fleet";
import Faq from "./pages/Faq";
import Blog from "./pages/blog/Blog";
import ProfessionalCorporateServices from "./pages/blog/ProfessionalCorporateServices";
import ChooseRightCharter from "./pages/blog/ChooseRightCharter";
import TransportationPlanningForWeddingsAndSpecialEvents from "./pages/blog/TransportationPlanningForWeddingsAndSpecialEvents";
import BenefitsOfTravelingInALuxurySprinterVan from "./pages/blog/BenefitsOfTravelingInALuxurySprinterVan";
import HowToPlanAStressFreeGroupJourney from "./pages/blog/HowToPlanAStressFreeGroupJourney";
import ReliableTransportationForBusinessEvents from "./pages/blog/ReliableTransportationForBusinessEvents";
import { AuthProvider } from "./context/AuthProvider";
import RequiredAuth from "./components/RequiredAuth";
import { AdminLayout } from "./pages/admin/AdminLayout";
import { Dashboard } from "./pages/admin/dashboard/Dashboard";
import { AdminSettingsLayout } from "./pages/adminSettings/AdminSettingsLayout";
import { UserRoles } from "./pages/adminSettings/userRoles/UserRoles";
import { DeleteProvider } from "./context/DeleteProvider";
import { ConfirmProvider } from "./context/ConfirmProvider";
import GetQuote from "./components/GetQuote";
import { Quotes } from "./pages/admin/quotes/Quotes";
import { EditQuote } from "./pages/admin/quotes/EditQuote";
import { ProfileProvider } from "./context/ProfileProvider";
import AccessControl from "./pages/adminSettings/accessControl/AccessControl";
import { AccessControlProvider } from "./context/AccessControlProvider";
import { AddUser } from "./pages/adminSettings/users/AddUser";
import { EditUser } from "./pages/adminSettings/users/EditUser";
import { Users } from "./pages/adminSettings/users/Users";
import Unauthorized from "./components/Unauthorized";
import { Rates } from "./pages/adminSettings/rates/Rates";
import { Seasons } from "./pages/adminSettings/seasons/Seasons";
import { OperatorTypes } from "./pages/adminSettings/operatorTypes/OperatorTypes";
import { AddRate } from "./pages/adminSettings/rates/AddRate";
import { EditRate } from "./pages/adminSettings/rates/EditRate";
import { AddOperatorType } from "./pages/adminSettings/operatorTypes/AddOperatorType";
import { EditOperatorType } from "./pages/adminSettings/operatorTypes/EditOperatorType";
import { AddSeason } from "./pages/adminSettings/seasons/AddSeason";
import { EditSeason } from "./pages/adminSettings/seasons/EditSeason";
import { Driver } from "./pages/adminSettings/driver/Driver";
import { GroupTypes } from "./pages/adminSettings/groupTypes/GroupTypes";
import { AddDriver } from "./pages/adminSettings/driver/AddDriver";
import { EditDriver } from "./pages/adminSettings/driver/EditDriver";
import { AddGroupType } from "./pages/adminSettings/groupTypes/AddGroupType";
import { EditGroupType } from "./pages/adminSettings/groupTypes/EditGroupType";
import { AutonomousOperators } from "./pages/adminSettings/autonomousOperators/AutonomousOperators";
import { AddAutonomousOperator } from "./pages/adminSettings/autonomousOperators/AddAutonomousOperator";
import { EditAutonomousOperator } from "./pages/adminSettings/autonomousOperators/EditAutonomousOperator";
import { AddFuelSurchargeRule } from "./pages/adminSettings/fuelSurchargeRules/AddFuelSurchargeRule";
import { EditFuelSurchargeRule } from "./pages/adminSettings/fuelSurchargeRules/EditFuelSurchargeRule";
import { FuelSurchargeRules } from "./pages/adminSettings/fuelSurchargeRules/FuelSurchargeRules";
import { GratuityRules } from "./pages/adminSettings/gratuityRules/GratuityRules";
import { AddGratuityRule } from "./pages/adminSettings/gratuityRules/AddGratuityRule";
import { EditGratuityRule } from "./pages/adminSettings/gratuityRules/EditGratuityRule";
import { AddVehicleRate } from "./pages/adminSettings/vehicleRates/AddVehicleRate";
import { EditVehicleRate } from "./pages/adminSettings/vehicleRates/EditVehicleRate";
import { VehicleRates } from "./pages/adminSettings/vehicleRates/VehicleRates";

const Roles = {
  Admin: "Admin"
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <AccessControlProvider>
          <ActiveNavBarProvider>
            <DeleteProvider>
              <ConfirmProvider>
                <ProfileProvider>
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/fleet" element={<Fleet />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/choose-the-right-charter" element={<ChooseRightCharter />} />
                    <Route path="/blog/benefits-of-professional-corporate-transportation-services" element={<ProfessionalCorporateServices />} />
                    <Route path="/blog/transportation-planning-for-weddings-and-special-events" element={<TransportationPlanningForWeddingsAndSpecialEvents />} />
                    <Route path="/blog/benefits-of-traveling-in-a-luxury-sprinter-van" element={<BenefitsOfTravelingInALuxurySprinterVan />} />
                    <Route path="/blog/how-to-plan-a-stress-free-group-journey" element={<HowToPlanAStressFreeGroupJourney />} />
                    <Route path="/blog/the-importance-of-reliable-transportation-for-business-events" element={<ReliableTransportationForBusinessEvents />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/get-quote" element={<GetQuote />} />
                    <Route path="/unauthorized" element={<Unauthorized />} />

                    <Route element={<RequiredAuth allowedRoles={[Roles.Admin]} />}>
                      <Route path="/admin" element={<AdminLayout />}>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="quotes" element={<Quotes />} />
                        <Route path="quotes/edit-quote" element={<EditQuote />} />
                      </Route>

                      <Route path="/admin/settings" element={<AdminSettingsLayout />}>
                        <Route path="users" element={<Users />} />
                        <Route path="users/add-user" element={<AddUser />} />
                        <Route path="users/edit-user" element={<EditUser />} />
                        <Route path="user-roles" element={<UserRoles />} />
                        <Route path="access-control" element={<AccessControl />} />
                        <Route path="rates" element={<Rates />} />
                        <Route path="rates/add-rate" element={<AddRate />} />
                        <Route path="rates/edit-rate" element={<EditRate />} />
                        <Route path="seasons" element={<Seasons />} />
                        <Route path="seasons/add-season" element={<AddSeason />} />
                        <Route path="seasons/edit-season" element={<EditSeason />} />
                        <Route path="operator-types" element={<OperatorTypes />} />
                        <Route path="operator-types/add-operator-type" element={<AddOperatorType />} />
                        <Route path="operator-types/edit-operator-type" element={<EditOperatorType />} />
                        <Route path="drivers" element={<Driver />} />
                        <Route path="drivers/add-driver" element={<AddDriver />} />
                        <Route path="drivers/edit-driver" element={<EditDriver />} />
                        <Route path="group-types" element={<GroupTypes />} />
                        <Route path="group-types/add-group-type" element={<AddGroupType />} />
                        <Route path="group-types/edit-group-type" element={<EditGroupType />} />
                        <Route path="autonomous-operators" element={<AutonomousOperators />} />
                        <Route path="autonomous-operators/add-autonomous-operator" element={<AddAutonomousOperator />} />
                        <Route path="autonomous-operators/edit-autonomous-operator" element={<EditAutonomousOperator />} />
                        <Route path="fuel-surcharge-rules" element={<FuelSurchargeRules />} />
                        <Route path="fuel-surcharge-rules/add-fuel-surcharge-rule" element={<AddFuelSurchargeRule />} />
                        <Route path="fuel-surcharge-rules/edit-fuel-surcharge-rule" element={<EditFuelSurchargeRule />} />

                        <Route path="gratuity-rules" element={<GratuityRules />} />
                        <Route path="gratuity-rules/add-gratuity-rule" element={<AddGratuityRule />} />
                        <Route path="gratuity-rules/edit-gratuity-rule" element={<EditGratuityRule />} />

                        <Route path="vehicle-rates" element={<VehicleRates />} />
                        <Route path="vehicle-rates/add-vehicle-rate" element={<AddVehicleRate />} />
                        <Route path="vehicle-rates/edit-vehicle-rate" element={<EditVehicleRate />} />
                      </Route>
                    </Route>
                  </Routes>

                  <Footer />
                </ProfileProvider>
              </ConfirmProvider>
            </DeleteProvider>
          </ActiveNavBarProvider>
        </AccessControlProvider>
      </AuthProvider>

    </Router>
  );
}

export default App;
